import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';

const Township = () => {
  return (
    <FormikInput
      placeholder="Enter township"
      name="township"
      id="township"
      label="Township"
    />
  );
};

export default Township;
